import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import {
	Stack,
	Step,
	Stepper,
	StepLabel,
	Button,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TextField,
	CircularProgress,
} from '@mui/material';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ContactsIcon from '@mui/icons-material/Contacts';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GoogleIcon from '@mui/icons-material/Google';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { post } from '../../util/api';
import { connect } from 'react-redux';

class GoogleContacts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 1,
			selectedAction: null,
			contacts: [],
			loading: true,
		};
	}

	async componentDidMount() {
		console.clear();
		try {
			const response = await post('/integrations/google', { product_id: this.props.product.settings.wapi_pid || this.props.product.id });
			const displayNames = response.data.displayNames;
			const verification = response.data.authUrl;
			this.setState({
				activeStep: verification ? 0 : 1,
				contacts: displayNames,
				loading: false,
			});
		} catch (error) {
			console.error('An error occurred while fetching data:', error);
			this.setState({ loading: false });
		}
	}

	fetchContacts = async () => {
		try {
			const response = await post('/integrations/google', { product_id: this.props.product.settings.wapi_pid || this.props.product.id });
			const { authUrl, displayNames } = response.data;

			if (authUrl) {
				window.open(authUrl, '_self');
				return;
			}

			this.setState({ contacts: displayNames });
		} catch (error) {
			console.error('An error occurred while fetching data:', error);
		}
	};

	handleAddContact = async () => {
		try {
			this.setState({ showSkeleton: true });
			const { givenName, familyName, number } = this.state;
			const addresponse = await post('/integrations/google/add-contact', {
				product_id: this.props.product.settings.wapi_pid || this.props.product.id,
				contact: { givenName, familyName, number },
			});
			if (addresponse.status === 200) {
				this.setState({ contactAddedSuccessfully: true, showSkeleton: false });
				this.handleTimeout();
			}
		} catch (error) {
			console.error('Error adding contact:', error);
			if (error.response && error.response.data && error.response.data.errorCode === 'PERSON_ALREADY_EXISTS') {
				this.setState({ contactNotAdded: true, showSkeleton: false });
				console.log('ERROR: ', error.response.data.errorCode);
			}
			this.handleTimeout();
		}
	};

	handleTimeout = () => {
		setTimeout(() => {
			this.setState({ contactAddedSuccessfully: false, contactNotAdded: false });
		}, 5000);
	};

	handleNext = () => {
		this.setState((prevState) => ({
			activeStep: prevState.activeStep + 1,
		}));
	};

	handleBack = () => {
		this.setState((prevState) => ({
			activeStep: prevState.activeStep - 1,
		}));
	};

	handleActionClick = (action) => {
		this.setState({
			selectedAction: action,
		});
	};

	render() {
		const steps = [
			{ label: 'Do Google authorization', icon: <GoogleIcon /> },
			{ label: 'Select Google Contact action', icon: <PermContactCalendarIcon /> },
			{ label: 'Complete the action', icon: <AssignmentTurnedInIcon /> },
		];
		if (this.state.loading) {
			return (
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100vh',
					}}
				>
					<CircularProgress disableShrink />
				</Box>
			);
		}
		return (
			<Stack>
				<Stepper style={{ display: 'none' }} activeStep={this.state.activeStep} alternativeLabel>
					{steps.map(({ label, icon }) => (
						<Step key={label}>
							<StepLabel icon={icon}>{label}</StepLabel>
						</Step>
					))}
				</Stepper>
				<div>
					{this.state.activeStep === 0 && (
						<Stack direction="column" justifyContent="center" alignItems="center" textAlign="center">
							<Typography variant="h5" gutterBottom>
								Do Google authorization
							</Typography>
							<Typography variant="body1" gutterBottom>
								You need authorization to use the Google Contacts integration
							</Typography>
							<br />
							<Button
								onClick={() => {
									this.fetchContacts();
									this.handleNext();
								}}
								style={{ border: '1px solid #6e89ed' }}
							>
								Authorize
							</Button>
						</Stack>
					)}
					{this.state.activeStep === 1 && (
						<Stack direction="column" justifyContent="center" alignItems="center" textAlign="center">
							<Typography variant="h5" gutterBottom>
								Select Google Contact action
							</Typography>
							<Typography variant="body1" gutterBottom>
								Select whichever Google Contact process you want to use.
							</Typography>
							<br />
							<Button
								variant="outlined"
								style={{
									width: '70%',
									height: '80px',
									marginBottom: '2%',
									fontSize: '15px',
									color: this.state.selectedAction === 'listContacts' ? '#10b981' : '#313b46',
									borderColor: this.state.selectedAction === 'listContacts' ? '#10b981' : '#313b46',
								}}
								onClick={() => this.handleActionClick('listContacts')}
							>
								<ContactsIcon fontSize="large" /> List contacts
							</Button>
							<Button
								variant="outlined"
								style={{
									width: '70%',
									height: '80px',
									marginBottom: '2%',
									fontSize: '15px',
									color: this.state.selectedAction === 'addContact' ? '#10b981' : '#313b46',
									borderColor: this.state.selectedAction === 'addContact' ? '#10b981' : '#313b46',
								}}
								onClick={() => this.handleActionClick('addContact')}
							>
								<PersonAddIcon fontSize="large" /> Add new contact
							</Button>
						</Stack>
					)}
					{this.state.activeStep === 2 && (
						<div style={{ textAlign: 'center' }}>
							{this.state.selectedAction === 'listContacts' && (
								<div>
									<Typography variant="h5" gutterBottom>
										View your Google contacts
									</Typography>
									<Typography variant="body1" gutterBottom>
										Allows you to access your contacts and information about them in the Google Contacts application.
										<Button
											variant="contained"
											onClick={this.handleBack}
											style={{ marginTop: '5px', display: this.state.activeStep === 1 || this.state.activeStep === 0 ? 'none' : 'block' }}
										>
											Back
										</Button>
										<TableContainer style={{ marginTop: '5px' }} component={Paper}>
											<Table style={{ width: 'maxWidth' }} aria-label="simple table">
												<TableHead>
													<TableRow>
														<TableCell>Names</TableCell>
														<TableCell align="right">Numbers</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{Array.isArray(this.state.contacts) ? (
														this.state.contacts.map((contact, index) => (
															<TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
																<TableCell style={{ fontSize: '15px' }} component="th" scope="row">
																	{contact.name}
																</TableCell>
																<TableCell style={{ fontSize: '15px' }} align="right">
																	{contact.number}
																</TableCell>
															</TableRow>
														))
													) : (
														<TableRow>
															<TableCell colSpan={2}>No contacts available</TableCell>
														</TableRow>
													)}
												</TableBody>
											</Table>
										</TableContainer>
									</Typography>
									<br />
								</div>
							)}
							{this.state.selectedAction === 'addContact' && (
								<div>
									<Typography variant="h5" gutterBottom textAlign="center">
										Add a new contact to your Google contact list
									</Typography>
									<p>
										You can add to your list using the name, surname and phone number of the person you want to add to your Google contacts
										list.
									</p>
									<TextField
										fullWidth
										label="Name"
										id="givenName"
										style={{ marginBottom: '10px', marginTop: '10px' }}
										required
										onChange={(e) => this.setState({ givenName: e.target.value })}
									/>
									<TextField
										fullWidth
										label="Surname"
										id="familyName"
										style={{ marginBottom: '10px' }}
										required
										onChange={(e) => this.setState({ familyName: e.target.value })}
									/>
									<TextField
										fullWidth
										label="Phone Number"
										id="number"
										style={{ marginBottom: '10px' }}
										maxLength="10"
										required
										onChange={(e) => {
											const enteredValue = e.target.value;
											const numericValue = enteredValue.replace(/\D/g, '');
											this.setState({ number: numericValue });
										}}
									/>
									<br />
									{this.state.showSkeleton && (
										<Box sx={{ width: '30%', margin: 'auto' }}>
											<Skeleton animation="wave" />
											<Skeleton animation="wave" />
											<Skeleton animation="wave" />
										</Box>
									)}
									{this.state.contactAddedSuccessfully && (
										<div>
											<p>
												<CheckCircleIcon style={{ fontSize: 80, color: 'green' }} />
												<br />
												New contact added successfully!
												<br />
												It may take some time to display the new contact in the list
												<br />
												You need to check by refreshing the page
											</p>
										</div>
									)}
									{this.state.contactNotAdded && (
										<div>
											<p>
												<ErrorIcon style={{ fontSize: 80, color: 'orange' }} />
												<br />
												The person you are trying to add is already on your list
											</p>
										</div>
									)}
								</div>
							)}
						</div>
					)}
					<Stack direction="row" justifyContent="space-around" spacing={2}>
						<Button
							variant="contained"
							onClick={this.handleBack}
							style={{
								display:
									this.state.selectedAction !== 'listContacts' && this.state.activeStep !== 1 && this.state.activeStep !== 0
										? 'block'
										: 'none',
							}}
						>
							Back
						</Button>
						<Button
							variant="contained"
							disabled={this.state.selectedAction === null}
							style={{ display: this.state.activeStep === 0 || this.state.activeStep === 2 ? 'none' : 'block' }}
							onClick={this.handleNext}
						>
							{this.state.activeStep === steps.length - 1 ? 'Complete' : 'Next'}
						</Button>
						<Button
							variant="contained"
							onClick={this.handleAddContact}
							disabled={!this.state.givenName || !this.state.familyName || !this.state.number}
							style={{ display: this.state.activeStep === 2 && this.state.selectedAction === 'addContact' ? 'block' : 'none' }}
						>
							Add Contact
						</Button>
					</Stack>
				</div>
			</Stack>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(GoogleContacts);
